import { Component, OnInit, Inject, ElementRef, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { CoursesService } from '../../../providers/courses.service';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from '../../../providers/login.service';
import { DashboardService } from '../../../providers/dashboard.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from "ngx-spinner";
import { CartService } from '../../../providers/cart.service';
import { JSONIDService } from '../../../providers/schema';
import { LoginModal } from '../../../pages/header/header.component';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-ipmat-mock-attempt',
  templateUrl: './ipmat-mock-attempt.component.html',
  styleUrls: ['./ipmat-mock-attempt.component.scss']
})
export class IpmatMockAttemptComponent implements OnInit{

  fullmockDetailList: any[] = [
    { name: 'IPMAT 1.0', type: 'full', lock: false, paid: true, launch: 'May 2024', _id: "655da2ac81ece0ddf3b5a4d4", setId: '6489757679bab1cda77e00fa', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT 2.0', type: 'full', lock: false, paid: true, launch: 'May 2024', _id: "648972c42157141dd71d6aa5", setId: '6489757679bab1cda77e00fa', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT 3.0', type: 'full', lock: false, paid: true, launch: 'May 2024', _id: "648973332157141dd71d6aa8", setId: '6489757679bab1cda77e00fa', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT 4.0', type: 'full', lock: true, paid: true, launch: 'May 2024', _id: "648973402157141dd71d6aab", setId: '6489757679bab1cda77e00fa', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT 5.0', type: 'full', lock: true, paid: true, launch: 'May 2024', _id: "6489734b79bab1cda77e00be", setId: '6489757679bab1cda77e00fa', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT 6.0', type: 'full', lock: true, paid: true, launch: 'May 2024', _id: "648973542157141dd71d6aaf", setId: '6489757679bab1cda77e00fa', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT 7.0', type: 'full', lock: true, paid: true, launch: 'May 2024', _id: "6489736379bab1cda77e00c0", setId: '6489757679bab1cda77e00fa', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT 8.0', type: 'full', lock: true, paid: true, launch: 'May 2024', _id: "6489737c79bab1cda77e00c3", setId: '6489757679bab1cda77e00fa', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT 9.0', type: 'full', lock: true, paid: true, launch: 'May 2024', _id: "6489739f2157141dd71d6abc", setId: '6489757679bab1cda77e00fa', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT 10.0', type: 'full', lock: true, paid: true, launch: 'May 2024', _id: "648973ad79bab1cda77e00c7", setId: '6489757679bab1cda77e00fa', link: 'https://iverse.iquanta.in/' },
  ];

  quantMockList: any[] = [
    { name: 'IPMAT Indore All India Mock', type: 'full', lock: true, paid: false, launch: '', _id: '664b1e461bb577c73a716841', setId: '664b2160844edbbedccaf58e', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 2025 FREE MOCK 1', type: 'full', lock: true, paid: false, launch: '', _id: '659d12dc4807d1a83e7a49f6', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 2025 FREE MOCK 2', type: 'full', lock: true, paid: false, launch: '', _id: '659d14caa464f324b0de0804', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 2025 FREE MOCK 3', type: 'full', lock: true, paid: false, launch: '', _id: '65d98f63a59236452d8c90be', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 4.0', type: 'full', lock: true, paid: true, launch: '', _id: '65d99393a59236452d8c928b', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 5.0', type: 'full', lock: true, paid: true, launch: '',  _id: '65d9c2b7a59236452d8c991d', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 6.0', type: 'full', lock: true, paid: true, launch: '',  _id: '65d9c507a59236452d8c9a0a', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 7.0', type: 'full', lock: true, paid: true, launch: '',  _id: '65d9c891a59236452d8c9bf7', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 8.0', type: 'full', lock: true, paid: true, launch: '',  _id: '65d9c9dea59236452d8c9c4c', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 9.0', type: 'full', lock: true, paid: true, launch: '',  _id: '65dec042a59236452d8cfa21', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 10.0', type: 'full', lock: true, paid: true, launch: '', _id: '65dec43aa59236452d8cfa6a', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 11.0', type: 'full', lock: true, paid: true, launch: '', _id: '65ebed81a59236452d8dab1f', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 12.0', type: 'full', lock: true, paid: true, launch: '', _id: '65ebeef1a59236452d8dab7f', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 13.0', type: 'full', lock: true, paid: true, launch: '', _id: '65ebf0bda59236452d8dabd8', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 14.0', type: 'full', lock: true, paid: true, launch: '', _id: '65ebf30ba59236452d8dad5e', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 15.0', type: 'full', lock: true, paid: true, launch: '', _id: '65ebf443a59236452d8dad9b', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 16.0', type: 'full', lock: true, paid: true, launch: '', _id: '6818b9fe35592331627ce72e', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 17.0', type: 'full', lock: true, paid: true, launch: '', _id: '681936af35592331627ce8e2', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 18.0', type: 'full', lock: true, paid: true, launch: '', _id: '681a330de0379bd478cd35d2', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 19.0', type: 'full', lock: true, paid: true, launch: '', _id: '681b14c435592331627cf9ec', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 20.0', type: 'full', lock: true, paid: true, launch: '', _id: '681c53de4d2f1dc883d1440a', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
  ];

  varcMockList: any[] = [
    { name: 'IPMAT Rohtak 1.0', type: 'full', lock: true, paid: true, launch: '', _id: '659d14f8a464f324b0de080c', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 2.0', type: 'full', lock: true, paid: true, launch: '', _id: '659d29f34807d1a83e7a5261', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 3.0', type: 'full', lock: true, paid: true, launch: '', _id: '65e18487a59236452d8d2652', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 4.0', type: 'full', lock: true, paid: true, launch: '', _id: '65e18618a59236452d8d26b7', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 5.0', type: 'full', lock: true, paid: true, launch: '', _id: '65e1983ea59236452d8d2aac', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 6.0', type: 'full', lock: true, paid: true, launch: '', _id: '65ebf777a59236452d8daeeb', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 7.0', type: 'full', lock: true, paid: true, launch: '', _id: '65ec08aea59236452d8db2a8', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 8.0', type: 'full', lock: true, paid: true, launch: '', _id: '65f297faa59236452d8e07e9', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 9.0', type: 'full', lock: true, paid: true, launch: '', _id: '65f29bc9a59236452d8e080e', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 10.0', type: 'full', lock: true, paid: true, launch: '', _id: '65f2a04aa59236452d8e08d9', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 11.0', type: 'full', lock: true, paid: true, launch: '', _id: '67e05dcf9f4376af7e934a80', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 12.0', type: 'full', lock: true, paid: true, launch: '', _id: '67e17e169f4376af7e9358ed', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 13.0', type: 'full', lock: true, paid: true, launch: '', _id: '67e29759b541f4eec7a30bb6', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 14.0', type: 'full', lock: true, paid: true, launch: '', _id: '67e2e1a6b541f4eec7a30efb', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 15.0', type: 'full', lock: true, paid: true, launch: '', _id: '67e5b65db541f4eec7a3290e', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 16.0', type: 'full', lock: true, paid: true, launch: '', _id: '67e7eddd9f4376af7e938a4f', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 17.0', type: 'full', lock: true, paid: true, launch: '', _id: '67e87895b541f4eec7a3372d', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 18.0', type: 'full', lock: true, paid: true, launch: '', _id: '6812793e35592331627cca83', setId: '65cb50677d768c2af04f84a3', link: 'https://iverse.iquanta.in/' },
  
  ];

  lrdiMockList: any[] = [
    { name: 'JIPMAT 1.0', type: 'full', lock: true, paid: true, launch: '', _id: '65cb5559a59236452d8b20d1', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 2.0', type: 'full', lock: true, paid: true, launch: '', _id: '65cb577ba59236452d8b2155', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 3.0', type: 'full', lock: true, paid: true, launch: '', _id: '65f2a5a8a59236452d8e08f0', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 4.0', type: 'full', lock: true, paid: true, launch: '', _id: '65f2a66aa59236452d8e0900', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 5.0', type: 'full', lock: true, paid: true, launch: '', _id: '65f2c084a59236452d8e0af8', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 6.0', type: 'full', lock: true, paid: true, launch: '', _id: '65f2c1e3a59236452d8e0b0f', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 7.0', type: 'full', lock: true, paid: true, launch: '', _id: '65f7e833a59236452d8e29fd', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 8.0', type: 'full', lock: true, paid: true, launch: '', _id: '67cfca0bd26ef27f9dafe6fc', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 9.0', type: 'full', lock: true, paid: true, launch: '', _id: '67d020490932b74ddf642063', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 10.0', type: 'full', lock: true, paid: true, launch: '', _id: '67d056ff02e55a74c41886cf', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 11.0', type: 'full', lock: true, paid: true, launch: '', _id: '67d1757ca242241b930000cc', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 12.0', type: 'full', lock: true, paid: true, launch: '', _id: '67d299152a91ee757dfe8403', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 13.0', type: 'full', lock: true, paid: true, launch: '', _id: '67d2d30a2a91ee757dfe85e2', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 14.0', type: 'full', lock: true, paid: true, launch: '', _id: '67d886a22a91ee757dfe94ae', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 15.0', type: 'full', lock: true, paid: true, launch: '', _id: '67d9b7509f4376af7e9304c5', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 16.0', type: 'full', lock: true, paid: true, launch: '', _id: '67daa63c9f4376af7e931c02', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 17.0', type: 'full', lock: true, paid: true, launch: '', _id: '67db18f2b541f4eec7a2becd', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 18.0', type: 'full', lock: true, paid: true, launch: '', _id: '67dbdda49f4376af7e932781', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 19.0', type: 'full', lock: true, paid: true, launch: '', _id: '67dc847db541f4eec7a2cc88', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 20.0', type: 'full', lock: true, paid: true, launch: '', _id: '67dd4fc2b541f4eec7a2eaed', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },

  ];

  pastPapers: any[]=[
    { name: 'IPMAT Indore 2025 Past Paper', type: 'full', lock: true, paid: false, launch: '', _id: '682dd4e54d2f1dc883d1985d', setId: '682dd9e0ed4b06e64fffc874', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore All India Mock', type: 'full', lock: true, paid: false, launch: '', _id: '664b1e461bb577c73a716841', setId: '664b2160844edbbedccaf58e', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 2024', type: 'past', lock: false, paid: false, launch: '', _id: '66d14e3b239ae5be0bf7248b', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 2023', type: 'past', lock: false, paid: false, launch: '', _id: '659393054807d1a83e798d41', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 2022', type: 'past', lock: false, paid: false, launch: '', _id: '658e6c5c4807d1a83e793dbf', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 2021', type: 'past', lock: false, paid: false, launch: '', _id: '658e6db4a464f324b0dd0115', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 2020', type: 'past', lock: false, paid: false, launch: '', _id: '659390274807d1a83e798bd4', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore 2019', type: 'past', lock: false, paid: false, launch: '', _id: '659392044807d1a83e798d09', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 2020', type: 'past', lock: false, paid: false, launch: '', _id: '65f2e1aba59236452d8e10a5', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Rohtak 2019', type: 'past', lock: false, paid: false, launch: '', _id: '65f2e0c9a59236452d8e1080', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 2024', type: 'full', lock: false, paid: false, launch: '', _id: '67f90964171e13e61d6eeb3c', setId: '65cb598c42702cd3b13867c8', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 2023', type: 'past', lock: false, paid: false, launch: '', _id: '6639fe28ed4d74416ef15719', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 2022', type: 'past', lock: false, paid: false, launch: '', _id: '66557a0a1bb577c73a71d7d7', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
    { name: 'JIPMAT 2021', type: 'past', lock: false, paid: false, launch: '', _id: '663a0adeed4d74416ef15807', setId: '65938ee312c5a77fbc3ee3d9', link: 'https://iverse.iquanta.in/' },
  ];

  pyqmock: any[]=[
    { name: 'NUMBERS PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '67122f923bf5fa94e7fbc38b', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'PERCENTAGE PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '67123192cf17339e4ae2932e', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: ' PROFIT AND LOSS PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '671233d23bf5fa94e7fbc464', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'MIXTURE & ALLIGATION PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '671235e4cf17339e4ae29416', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'TIME, SPEED & DISTANCE PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '671237eecf17339e4ae29492', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'PIPES AND CISTERNS PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '67123a843bf5fa94e7fbc5c6', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'AVERAGE PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '67123cdd3bf5fa94e7fbc641', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'RATIO & PROPORTION PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '67123ef2cf17339e4ae29601', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'SIMPLE AND COMPOUND INTEREST PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '671240663bf5fa94e7fbc74c', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'QUADRATIC EQUATION PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '671241713bf5fa94e7fbc7c3', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'MAXIMA & MINIMA PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '671242e83bf5fa94e7fbc7e9', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'AP & GP  PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '671244dc3bf5fa94e7fbc898', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'CO-ORDINATE GEOMETRY PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '671246be3bf5fa94e7fbc96e', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'FUNCTIONS AND MODULUS  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '67124a053bf5fa94e7fbcae9', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'LINEAR EQUATIONS  PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '67124bdd3bf5fa94e7fbcb40', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'LOGARITHMS  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '67124d7bcf17339e4ae29b7a', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'BINOMIAL THEOREM  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '67124e193bf5fa94e7fbcc6b', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'DATA INTERPRETATIONS  PYQ ', type: 'past', lock: false, paid: false, launch: '', _id: '671250833bf5fa94e7fbcdda', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'PERMUTATION COMBINATION  PYQs', type: 'past', lock: false, paid: false, launch: '', _id: '6712525bcf17339e4ae29e34', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'PROBABILITY  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '671252fbcf17339e4ae29e7e', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'INEQUALITIES  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715d6133bf5fa94e7fbd53b', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'TRIGONOMETRY  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715d6ff3bf5fa94e7fbd56f', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'MATRICES & DETERMINANTS  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715dc0dcf17339e4ae2a566', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'RANGE AND DOMAIN  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715dce1cf17339e4ae2a583', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'SET THEORY & VENN DIAGRAMS  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715de143bf5fa94e7fbd75e', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'RELATIONS  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715dfbbcf17339e4ae2a68c', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'GEOMETRY  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715e2c3cf17339e4ae2a82b', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'MENSURATION  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715e3eecf17339e4ae2a885', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'READING COMPREHENSION  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715eaddcf17339e4ae2aaa2', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'PHRASAL VERBS  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715ed893bf5fa94e7fbdc88', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'SENTENCE CORRECTION  PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715ee8ccf17339e4ae2ab95', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'PARA COMPLETION ALL PYQs- IPMAT INDORE ', type: 'past', lock: false, paid: false, launch: '', _id: '6715f04ccf17339e4ae2ac4d', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'FILL IN THE BLANKS ALL PYQs- IPMAT INDORE ', type: 'past', lock: false, paid: false, launch: '', _id: '6715f12f3bf5fa94e7fbddec', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'ERROR DETECTION ALL PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715f1f6cf17339e4ae2ad03', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'PARAJUMBLE ALL PYQs ', type: 'past', lock: false, paid: false, launch: '', _id: '6715f298cf17339e4ae2ad3a', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
  ];

  INDOREQA: any[]=[
    { name: 'IPMAT INDORE QA SA Sectional 1', type: 'full', lock: true, paid: false, launch: '', _id: '678a34e253142c8a8d3f12bd', setId: '678a57eab98d40356fb8a70b', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA SA Sectional 2', type: 'full', lock: true, paid: false, launch: '', _id: '678a52151fc82d514ca05b2b', setId: '678a57eab98d40356fb8a70b', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA SA Sectional 3', type: 'full', lock: true, paid: false, launch: '', _id: '678b6d2353142c8a8d3f19dc', setId: '678a57eab98d40356fb8a70b', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA SA Sectional 4', type: 'full', lock: true, paid: false, launch: '', _id: '678de2751fc82d514ca06829', setId: '678a57eab98d40356fb8a70b', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA SA Sectional 5', type: 'full', lock: true, paid: false, launch: '', _id: '678e259953142c8a8d3f22d1', setId: '678a57eab98d40356fb8a70b', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA SA Sectional 6', type: 'full', lock: true, paid: false, launch: '', _id: '67af1106afad47201a8a56b4', setId: '678a57eab98d40356fb8a70b', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA SA Sectional 7', type: 'full', lock: true, paid: false, launch: '', _id: '67b47225afad47201a8a6d95', setId: '678a57eab98d40356fb8a70b', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA SA Sectional 8', type: 'full', lock: true, paid: false, launch: '', _id: '67c1931a81e0fa8041be6a89', setId: '678a57eab98d40356fb8a70b', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA SA Sectional 9', type: 'full', lock: true, paid: false, launch: '', _id: '67c19fcb81e0fa8041be6bf9', setId: '678a57eab98d40356fb8a70b', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA SA Sectional 10', type: 'full', lock: true, paid: false, launch: '', _id: '67c1af7281e0fa8041be6db8', setId: '678a57eab98d40356fb8a70b', link: 'https://iverse.iquanta.in/' },
  ];

  INDOREQAMCQ:any[]=[
    { name: 'IPMAT INDORE QA MCQ Sectional 1', type: 'full', lock: true, paid: false, launch: '', _id: '67c585d17390212d87f7d360', setId: '67c840a43023d5fa9a87150d', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA Sectional 2', type: 'full', lock: true, paid: true, launch: '', _id: '67ead7ab9f4376af7e93a0fb', setId: '67c840a43023d5fa9a87150d', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA Sectional 3', type: 'full', lock: true, paid: true, launch: '', _id: '67eb05c6b541f4eec7a34a80', setId: '67c840a43023d5fa9a87150d', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore QA Sectional 4', type: 'full', lock: true, paid: true, launch: '', _id: '67eb1b35b541f4eec7a34b11', setId: '67c840a43023d5fa9a87150d', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA Sectional 5', type: 'full', lock: true, paid: true, launch: '', _id: '67ebe5ad9f4376af7e93b145', setId: '67c840a43023d5fa9a87150d', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA Sectional 6', type: 'full', lock: true, paid: true, launch: '', _id: '67ec3711b541f4eec7a35b55', setId: '67c840a43023d5fa9a87150d', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA Sectional 7', type: 'full', lock: true, paid: true, launch: '', _id: '67ec69289f4376af7e93b306', setId: '67c840a43023d5fa9a87150d', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA Sectional 8', type: 'full', lock: true, paid: true, launch: '', _id: '67ee4db79f4376af7e93c396', setId: '67c840a43023d5fa9a87150d', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT INDORE QA Sectional 9', type: 'full', lock: true, paid: true, launch: '', _id: '67eedb9244f46d56080d2f80', setId: '67c840a43023d5fa9a87150d', link: 'https://iverse.iquanta.in/' },
  
  ];

  IndoreVA:any[]=[
    { name: 'IPMAT Indore VA Sectional 1', type: 'full', lock: true, paid: true, launch: '', _id: '67e9790b9f4376af7e93955c', setId: '67ea1b052502fe28e4bfbc23', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore VA Sectional 2', type: 'full', lock: true, paid: true, launch: '', _id: '67e9a5209f4376af7e9395c1', setId: '67ea1b052502fe28e4bfbc23', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore VA Sectional 3', type: 'full', lock: true, paid: true, launch: '', _id: '67e9bd429f4376af7e939667', setId: '67ea1b052502fe28e4bfbc23', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore VA Sectional 4', type: 'full', lock: true, paid: true, launch: '', _id: '67ea519ab541f4eec7a34540', setId: '67ea1b052502fe28e4bfbc23', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore VA Sectional 5', type: 'full', lock: true, paid: true, launch: '', _id: '67ea723e9f4376af7e939f6d', setId: '67ea1b052502fe28e4bfbc23', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore VA Sectional 6', type: 'full', lock: true, paid: true, launch: '', _id: '67f150c944f46d56080d4148', setId: '67ea1b052502fe28e4bfbc23', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore VA Sectional 7', type: 'full', lock: true, paid: true, launch: '', _id: '67f193fd171e13e61d6e9f1d', setId: '67ea1b052502fe28e4bfbc23', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore VA Sectional 8', type: 'full', lock: true, paid: true, launch: '', _id: '67f275fa171e13e61d6ea025', setId: '67ea1b052502fe28e4bfbc23', link: 'https://iverse.iquanta.in/' },
    { name: 'IPMAT Indore VA Sectional 9', type: 'full', lock: true, paid: true, launch: '', _id: '67f3b5e1171e13e61d6eb7ce', setId: '67ea1b052502fe28e4bfbc23', link: 'https://iverse.iquanta.in/' },

  ];

  Rohtak: any[]=[
    { name: 'NUMBERS ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6735cca44bc5bc344635b239', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'PERCENTAGE ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6735cf4ea0934153abe15ba5', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'PROFIT AND LOSS ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6735d04aa0934153abe15bf9', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'TIME, SPEED & DISTANCE ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6735d2054bc5bc344635b368', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'TIME & WORK ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6735d635a0934153abe15dc9', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'PIPES & CISTERNS All PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6735db5ea0934153abe15e7a', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'AVERAGE ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6735e0384bc5bc344635b5ce', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'RATIO & PROPORTION ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6735e44b4bc5bc344635b696', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'SIMPLE & COMPOUND INTEREST ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6735e7204bc5bc344635b7b3', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'QUADRATIC EQUATION ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6735e8d2a0934153abe160fb', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'AP & GP ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6736c68ea0934153abe16225', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'FUNCTIONS AND MODULUS ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736c92ca0934153abe16287', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'LINEAR EQUATIONS ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736ccae4bc5bc344635b9d4', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'LOGARITHMS ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736cf0da0934153abe16346', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'SENTENCE CORRECTION ALL PYQ ', type: 'full', lock: true, paid: false, launch: '', _id: '6736deb2a0934153abe16812', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'PARA COMPLETION ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736e0ec4bc5bc344635bfd2', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'ERROR DETECTION ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736e1e64bc5bc344635c02d', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'PARAJUMBLE ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6736e42da0934153abe1699e', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'ANALOGY ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6736e5564bc5bc344635c0fb', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'WORD USAGE ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736e6864bc5bc344635c14c', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'SENTENCE COMPLETION ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6736e8674bc5bc344635c23c', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'ONE WORD SUBSTITUTION ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736e9a74bc5bc344635c2e5', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'LINEAR ARRANGEMENT ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736ebaaa0934153abe16d01', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },{ name: 'NUMBERS ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6735cca44bc5bc344635b239', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'VISUAL REASONING ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6736ec8ea0934153abe16d80', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'CODING DECODING ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6736ed66a0934153abe16de8', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'DISTANCE & DIRECTION ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736ef40a0934153abe16e32', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'FACTS INFERENCE JUDGEMENT ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6736f1c5a0934153abe16ec6', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },{ name: 'NUMBERS ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6735cca44bc5bc344635b239', setId: '6716026a23f7069204fc5a4f', link: 'https://iverse.iquanta.in/' },
    { name: 'RANKING AND ORDER ALL PYQs  ', type: 'full', lock: true, paid: false, launch: '', _id: '6736f2f74bc5bc344635c60d', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'PUZZLE ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736f3a2a0934153abe16f2d', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'SEQUENCE ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736f4fc4bc5bc344635c676', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'BLOOD RELATION ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736f5b34bc5bc344635c6a1', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'LOGICAL ANALOGY ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736f6744bc5bc344635c6d6', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'STATEMENT & CONCLUSION ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736f8f84bc5bc344635c7be', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'LOGICAL OPERATIONS ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736f9e6a0934153abe17100', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'INDICES & SURDS ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736fb3ba0934153abe17138', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'DATA SUFFIECIENCY ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736fc984bc5bc344635c8e9', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'INPUT & OUTPUT ALL PYQs ', type: 'full', lock: true, paid: false, launch: '', _id: '6736fd764bc5bc344635c926', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'CLOCKS ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736fdfba0934153abe17258', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'DATA INTERPRETATION ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736d116a0934153abe16410', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'PERMUTATION COMBINATION ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736d3794bc5bc344635bc55', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'PROBABILITY ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736d4afa0934153abe165c5', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'INEQUALITIES ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736d5f3a0934153abe1661f', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'TRIGONOMETRY ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736d8524bc5bc344635bd69', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'GEOMETRY ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736db424bc5bc344635bdcf', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
    { name: 'READING COMPREHENSION ALL PYQs', type: 'full', lock: true, paid: false, launch: '', _id: '6736dc8b4bc5bc344635be1b', setId: '6736fc560ff2adb91aeb10e6', link: 'https://iverse.iquanta.in/' },
  ];
  
  iim: any[]=[
    { name: 'IIM BANGALORE BBA 2024 PAPER ', type: 'full', lock: false, paid: false, launch: '', _id: '676126213aea289f2b053e7b', setId: '6687fb682debe8fe3c6e1b1a', link: 'https://iverse.iquanta.in/' },
    { name: 'IIM BANGALORE BBA MOCK 1 ', type: 'full', lock: false, paid: true, launch: '', _id: '6687d7e5af6b55baf6030442', setId: '6687fb682debe8fe3c6e1b1a', link: 'https://iverse.iquanta.in/' },
    { name: 'IIM BANGALORE BBA MOCK 2', type: 'full', lock: false, paid: true, launch: '', _id: '669635321a6d980dc6363335', setId: '6687fb682debe8fe3c6e1b1a', link: 'https://iverse.iquanta.in/' },
    { name: 'IIM BANGALORE BBA MOCK 3 ', type: 'full', lock: false, paid: true, launch: '', _id: '669b82591a6d980dc636b254', setId: '6687fb682debe8fe3c6e1b1a', link: 'https://iverse.iquanta.in/' },
    { name: 'IIM BANGALORE BBA MOCK 4 ', type: 'full', lock: false, paid: true, launch: '', _id: '669b83611a6d980dc636b2ab', setId: '6687fb682debe8fe3c6e1b1a', link: 'https://iverse.iquanta.in/' },
    { name: 'IIM BANGALORE BBA MOCK 5', type: 'full', lock: false, paid: true, launch: '', _id: '669b844d1a6d980dc636b2df', setId: '6687fb682debe8fe3c6e1b1a', link: 'https://iverse.iquanta.in/' },
  ];

  SETMockList: any[] = [
    { name: 'SET Mock 1.0', type: 'full', lock: true, paid: true, launch: '', _id: '65fd10e4a59236452d8e6910', setId: '65fd149224e11a489c55fcfa', link: 'https://iverse.iquanta.in/' },
    { name: 'SET Mock 2.0', type: 'full', lock: true, paid: true, launch: '', _id: '65fd62e5a59236452d8e78db', setId: '65fd149224e11a489c55fcfa', link: 'https://iverse.iquanta.in/' },
    { name: 'SET Mock 3.0', type: 'full', lock: true, paid: true, launch: '', _id: '65fecc85a59236452d8e8b8f', setId: '65fd149224e11a489c55fcfa', link: 'https://iverse.iquanta.in/' },
    { name: 'SET Mock 4.0', type: 'full', lock: true, paid: true, launch: '', _id: '6604eb4fa59236452d8eaef7', setId: '65fd149224e11a489c55fcfa', link: 'https://iverse.iquanta.in/' },
    { name: 'SET Mock 5.0', type: 'full', lock: true, paid: true, launch: '', _id: '6604ed61a59236452d8eb03c', setId: '65fd149224e11a489c55fcfa', link: 'https://iverse.iquanta.in/' },
  ];

  XETMockList: any[] = [
    { name: 'XET Mock 1.0', type: 'full', lock: true, paid: true, launch: '', _id: '659d12dc4807d1a83e7a49f6', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'XET Mock 2.0', type: 'full', lock: true, paid: true, launch: '', _id: '659d14caa464f324b0de0804', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'XET Mock 3.0', type: 'full', lock: true, paid: true, launch: '', _id: '65d98f63a59236452d8c90be', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'XET Mock 4.0', type: 'full', lock: true, paid: true, launch: '', _id: '65d99393a59236452d8c928b', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
  ];

  NPATMockList: any[] = [
    { name: 'NPAT Mock 1.0', type: 'full', lock: true, paid: true, launch: '', _id: '65fc1989a59236452d8e6518', setId: '65fd135924e11a489c55fcf9', link: 'https://iverse.iquanta.in/' },
    { name: 'NPAT Mock 2.0', type: 'full', lock: true, paid: true, launch: '', _id: '65fd5ff7a59236452d8e785c', setId: '65fd135924e11a489c55fcf9', link: 'https://iverse.iquanta.in/' },
    { name: 'NPAT Mock 3.0', type: 'full', lock: true, paid: true, launch: '', _id: '65fec7aaa59236452d8e8a93', setId: '65fd135924e11a489c55fcf9', link: 'https://iverse.iquanta.in/' },
    { name: 'NPAT Mock 4.0', type: 'full', lock: true, paid: true, launch: '', _id: '66040dd3a59236452d8eaa7e', setId: '65fd135924e11a489c55fcf9', link: 'https://iverse.iquanta.in/' },
    { name: 'NPAT Mock 5.0', type: 'full', lock: true, paid: true, launch: '', _id: '6604147aa59236452d8eabfc', setId: '65fd135924e11a489c55fcf9', link: 'https://iverse.iquanta.in/' },
  ];

  CHRISTMockList: any[] = [
    { name: 'CHRIST Mock 1.0', type: 'full', lock: true, paid: true, launch: '', _id: '66069fc8a59236452d8efffb', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'CHRIST Mock 2.0', type: 'full', lock: true, paid: true, launch: '', _id: '660aa30ca59236452d8f421a', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'CHRIST Mock 3.0', type: 'full', lock: true, paid: true, launch: '', _id: '660aa66ca59236452d8f4307', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'CHRIST Mock 4.0', type: 'full', lock: true, paid: true, launch: '', _id: '660aaa70a59236452d8f43d3', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'CHRIST Mock 5.0', type: 'full', lock: true, paid: true, launch: '', _id: '660aac10a59236452d8f440d', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
  ];

  BMSBBAMockList: any[] = [
    { name: 'XAVIERS BMS MOCK 1', type: 'full', lock: false, paid: false, launch: '', _id: '660b9447a59236452d8f46c4', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'XAVIERS BMS MOCK 2', type: 'full', lock: false, paid: false, launch: '', _id: '67763d653aea289f2b05cab0', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'XAVIERS BMS MOCK 3', type: 'full', lock: false, paid: false, launch: '', _id: '67765366445e851389f8f1bd', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'XAVIERS BMS MOCK 4', type: 'full', lock: false, paid: false, launch: '', _id: '677657b63aea289f2b05ccba', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
  ];

  CETBBAMockList: any[] = [
    { name: 'IPU CET MOCK 1', type: 'full', lock: false, paid: false, launch: '', _id: '660b9ad9a59236452d8f4778', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'IPU CET MOCK 2', type: 'full', lock: false, paid: false, launch: '', _id: '677b9a5c445e851389f90658', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'IPU CET MOCK 3', type: 'full', lock: false, paid: false, launch: '', _id: '677ba078445e851389f9070c', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'IPU CET MOCK 4', type: 'full', lock: false, paid: false, launch: '', _id: '677ba2063aea289f2b05e2c4', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
    { name: 'IPU CET MOCK 5', type: 'full', lock: false, paid: false, launch: '', _id: '677ba9153aea289f2b05e3a0', setId: '660b9777e038de82bd5c9e7f', link: 'https://iverse.iquanta.in/' },
  ];

  IPUMockList: any[] = [
    { name: 'IPU Mock 1.0', type: 'full', lock: true, paid: true, launch: '', _id: '659d12dc4807d1a83e7a49f6', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPU Mock 2.0', type: 'full', lock: true, paid: true, launch: '', _id: '659d14caa464f324b0de0804', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPU Mock 3.0', type: 'full', lock: true, paid: true, launch: '', _id: '65d98f63a59236452d8c90be', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
    { name: 'IPU Mock 4.0', type: 'full', lock: true, paid: true, launch: '', _id: '65d99393a59236452d8c928b', setId: '65cb50c77d768c2af04f84a4', link: 'https://iverse.iquanta.in/' },
  ];




   Kozhikode: any[]=[
    { name: 'IIM Kozhikode BMS Mock 1', type: 'full', lock: true, paid: true, launch: '', _id: '684eeec738dab8968fd9d3b0', setId: '685130d83c08a3e66e3b431c', link: 'https://iverse.iquanta.in/' },
    
  ];

  token:any;
  @ViewChild("myTooltip") myTooltip!: MatTooltip;

  profileData:any;
  mockData:any;
  tabVal: any = 'pastpapers';
  loadmore1: any = 5;
  loadmore2: any = 5;
  loadmore3: any = 5;
  loadmore4: any = 5;
  loadmore5: any = 7;

  constructor(@Inject(LOCAL_STORAGE) public sessionStorage: any, public coursesService: CoursesService,
   public spinner: NgxSpinnerService, public cartService: CartService,
    public router: Router,  public matSnackBar: MatSnackBar,
    public dialog: MatDialog, public loginService: LoginService, public dashboardService: DashboardService,
    public mockService: JSONIDService, ) { }

  ngOnInit(): void {
    this.getAllCourses()
    if (this.sessionStorage.getItem('usertoken')) {
      this.token = this.sessionStorage.getItem('usertoken');
      this.profileData = JSON.parse(this.sessionStorage.getItem('userData'));
      this.mockData = JSON.parse(this.sessionStorage.getItem('mockData'))
      this.getProfile()
    }
    this.getProfileData()
    this.getMockLinks()
  }

  registerforFree(){
    window.open('https://qr.iquanta.in/r/mcD-CkWfuh', '_blank')
  }

  gotoyoutube(cbcObj: any) {
    if (cbcObj.youtubeLink) {
      window.open(cbcObj.youtubeLink, '_blank')
    } else if (cbcObj.facebookLink) {
      window.open(cbcObj.facebookLink, '_blank')
    }
  }

  tabVal1: any = 'quant'
  changeTab(val: any) {
    this.tabVal = val;
    if(val == 'bba'){
      this.tabVal1 = 'SET'
    }else{
       this.tabVal1 = 'quant'
    }
  }
  changeTab1(val: any) {
    this.tabVal1 = val;
  }

  linkList: any[] = []
  getMockLinks() {
    this.coursesService.getMockLinks().subscribe(res => {
      if (res.length > 0) {
        this.linkList = res;
      }
    })
  }

  
  getProfileData() {
    this.loginService.profileData.subscribe(res => {
      this.token = this.sessionStorage.getItem('usertoken');
      if (this.sessionStorage.getItem('userData')) {
        this.profileData = JSON.parse(this.sessionStorage.getItem('userData'));
        this.mockData = JSON.parse(this.sessionStorage.getItem('mockData'))
       this.getStatus()
      } else {
        this.profileData = '';
        this.token = ''
      }

    })
  }

  getProfile() {
    this.dashboardService.getProfile(this.token).subscribe(res => {
      if (res.success) {
        this.profileData = res.data[0];
        this.sessionStorage.setItem('userData', JSON.stringify(this.profileData));
        this.sessionStorage.setItem('mockData', JSON.stringify(res.mock_login))
        this.mockData = res.mock_login;
        this.getStatus();
        this.getMocks()
        this.loginService.userProfile(this.profileData)

      }
    })
  }

  
  viewanalysis(mockObj: any, attempt:any, index:any) {
    
    if (this.token) {
      // if(this.tabVal == 'freemocks' || this.tabVal == 'pastpapers'){
      //   this.coursesService.getOtp(this.mockData.email).subscribe(res => {
      //     if (res.otp) {
      //       this.spinner.hide();
      //       window.open('https://iverse.iquanta.in/' + this.mockData.email + '/' + res.otp + '/' +
      //         mockObj.setId + '/' + mockObj._id)
      //     }
      //   })
      // }else{
        if(index > 0){
          if(!mockObj.isWindowPeriod){
            this.spinner.show();
            this.coursesService.getOtp(this.mockData.email).subscribe(res => {
              if (res.otp) {
                this.spinner.hide();
                  window.open('https://iverse.iquanta.in/' + this.mockData.email + '/' + res.otp + '/' +
                    mockObj.setId + '/' + mockObj._id + '?pageType=viewAnalysis&attemptId='+ attempt.attemptId)
              }
            })
          }else{
            this.matSnackBar.open('Reattempt will be available after the window period', 'OK', {
              verticalPosition: 'top',
              duration: 3000,
              panelClass: 'snack-error'
            })
          }
        }else{
          this.spinner.show();
          this.coursesService.getOtp(this.mockData.email).subscribe(res => {
            if (res.otp) {
              this.spinner.hide();
                window.open('https://iverse.iquanta.in/' + this.mockData.email + '/' + res.otp + '/' +
                  mockObj.setId + '/' + mockObj._id + '?pageType=viewAnalysis&attemptId='+ attempt.attemptId)
            }
          })
        }
      // }
    } else {
      this.spinner.hide();
      const dialogRef = this.dialog.open(LoginModal, {
        width: '750px',
        panelClass: 'login_modal',
        autoFocus: false
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {

        } else if (typeof (result) == 'object') {
          if (this.sessionStorage.getItem('usertoken')) {
            this.token = this.sessionStorage.getItem('usertoken');
            this.getProfile()

          } else {
            this.profileData = result;
            this.token = this.sessionStorage.getItem('usertoken');;
            this.sessionStorage.setItem('userData', JSON.stringify(result));
            this.profileData.userProfile(this.profileData)
            window.open(this.linkList[0].view_analysis_url + this.mockData.email + '/' + this.mockData.otp + '/' +
              '6489757679bab1cda77e00fa' + '/' + '648972c42157141dd71d6aa5')

          }
        }
      });
    }
  }

  resume(mockObj: any, attempt:any, index:any) {
    if (this.token) {
      // if(this.tabVal == 'freemocks' || this.tabVal == 'pastpapers'){
      //   this.coursesService.getOtp(this.mockData.email).subscribe(res => {
      //     if (res.otp) {
      //       this.spinner.hide();
      //       window.open('https://iverse.iquanta.in/' + this.mockData.email + '/' + res.otp + '/' +
      //         mockObj.setId + '/' + mockObj._id)
      //     }
      //   })
      // }else{
        if(index > 0){
          if(!mockObj.isWindowPeriod){
        this.spinner.show();
        this.coursesService.getOtp(this.mockData.email).subscribe(res => {
          if (res.otp) {
            this.spinner.hide();
              window.open('https://iverse.iquanta.in/' + this.mockData.email + '/' + res.otp + '/' +
                mockObj.setId + '/' + mockObj._id + '?pageType=resume&attemptId='+ attempt.attemptId)
          }
        })
          }else{
            this.matSnackBar.open('Reattempt will be available after the window period', 'OK', {
              verticalPosition: 'top',
              duration: 3000,
              panelClass: 'snack-error'
            })
          }
        }else{
          this.spinner.show();
          this.coursesService.getOtp(this.mockData.email).subscribe(res => {
            if (res.otp) {
              this.spinner.hide();
                window.open('https://iverse.iquanta.in/' + this.mockData.email + '/' + res.otp + '/' +
                  mockObj.setId + '/' + mockObj._id + '?pageType=resume&attemptId='+ attempt.attemptId)
            }
          })
        }
      // }

    }
  }

  startMock(mockObj: any) {
    if (this.token) {
      // if(this.tabVal == 'freemocks' || this.tabVal == 'pastpapers'){
      //   this.coursesService.getOtp(this.mockData.email).subscribe(res => {
      //     if (res.otp) {
      //       this.spinner.hide();
      //       window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
      //         mockObj.setId + '/' + mockObj._id)
      //     }
      //   }, err=>{
      //     this.resetAccount()
      //   })
      // }else{
      if(mockObj.attemptList){
        if(!mockObj.attemptList[0].attemptId){
          this.spinner.show();
          this.coursesService.getOtp(this.mockData.email).subscribe(res => {
            if (res.otp) {
              this.spinner.hide();
              if (this.tabVal == 'full' || this.tabVal == 'unproctored' || this.tabVal == 'freemocks' || this.tabVal == 'pastpapers') {
                if(mockObj.attemptList[0].mockStatus){
                  window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                    mockObj.setId + '/' + mockObj._id)
                }else{
                  window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                    mockObj.setId + '/' + mockObj._id + '?pageType=startMock')
                }
              
              }
              // else if(this.tabVal == 'pastpapers'){
              //   window.open('https://iverse.iquanta.in/' + this.mockData.email + '/' + res.otp + '/' +
              //   mockObj.setId + '/' + mockObj._id)
              // }
               else {
                if (this.tabVal1 == 'quant') {
                  window.open('https://iverse.iquanta.in/' + this.mockData.email + '/' + res.otp + '/' +
                    mockObj.setId + '/' + mockObj._id)
                } else if (this.tabVal1 == 'varc') {
                  window.open('https://iverse.iquanta.in/' + this.mockData.email + '/' + res.otp + '/' +
                    mockObj.setId + '/' + mockObj._id)
                } else if (this.tabVal1 == 'lrdi') {
                  window.open('https://iverse.iquanta.in/' + this.mockData.email + '/' + res.otp + '/' +
                    mockObj.setId + '/' + mockObj._id)
                }
    
              }
            }
          }, err=>{
            this.resetAccount()
          })
        }else{
          if(!mockObj.isWindowPeriod){
            this.spinner.show();
            this.coursesService.getOtp(this.mockData.email).subscribe(res => {
              if (res.otp) {
                this.spinner.hide();
             
                    window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                      mockObj.setId + '/' + mockObj._id + '?pageType=startMock')
                 
                
              }
            }, err=>{
              this.resetAccount()
            })
          }else{
            this.matSnackBar.open('Reattempt will be available after the window period', 'OK', {
              verticalPosition: 'top',
              duration: 3000,
              panelClass: 'snack-error'
            })
          }
        }
      }else{
            this.coursesService.getOtp(this.mockData.email).subscribe(res => {
          if (res.otp) {
            this.spinner.hide();
            window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
              mockObj.setId + '/' + mockObj._id)
          }
        }, err=>{
          this.resetAccount()
        })
      }
       
      // }
     
    } else {
      const dialogRef = this.dialog.open(LoginModal, {
        width: '750px',
        panelClass: 'login_modal',
        autoFocus: false
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {

        } else if (typeof (result) == 'object') {
          if (this.sessionStorage.getItem('usertoken')) {
            this.token = this.sessionStorage.getItem('usertoken');
            this.getProfile()

          } else {
            this.profileData = result;
            this.token = this.sessionStorage.getItem('usertoken');;
            this.sessionStorage.setItem('userData', JSON.stringify(result));
            this.profileData.userProfile(this.profileData)
            this.spinner.show();
            this.coursesService.getOtp(this.mockData.email).subscribe(res => {
              if (res.otp) {
                this.spinner.hide();
                window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                  mockObj.setId + '/' + mockObj._id + '?pageType=startMock')
             
              }
            })

          }
        }
      });
    }
  }


  allMocksList: any[] = []

  coursesArray: any[] = []

  coursesArray1:any[]=[]
  getAllCourses() {
    this.coursesService.getAllCourses().subscribe(res => {
      if (res.length > 0) {
        this.coursesArray1 = res.filter((x:any)=> !x.is_rq);
        if (!this.sessionStorage.getItem('usertoken')) {
        this.getMocks()
        }
      }
    })
  }
  mockList:any[]=[]
  getCourses() {
    this.coursesService.getEnableAndDisabledCourses().subscribe(res => {
      if (res.success) {
        this.coursesArray = res.data.filter((x:any)=> !x.is_rq);
        let purchasedCourses: any[] = []
        this.coursesArray.forEach(mock => {
          if (this.profileData.course_ids.includes(mock.id)) {
            purchasedCourses.push(mock)
          }
        })
        if (purchasedCourses.length > 0) {
          this.setPaidUnPaid(purchasedCourses)

        }
      }
    })
  }

  getMocks() {
    this.getCourses()
    this.coursesService.getPagewiseCourses('IPMAT', 'Mocks', '2024').subscribe(res => {
      if (res.success) {
        this.mockList = res.data[0].course;
        let purchasedCourses: any[] = []
        this.mockList.forEach(mock => {
          if (this.profileData.course_ids.includes(mock.id)) {
            purchasedCourses.push(mock)
          }
        })
        if (purchasedCourses.length > 0) {
          this.setPaidUnPaid(purchasedCourses)

        }
      }
    })
  }


  getStatus() {
    let reqObj = {
      uid: this.mockData.uid,
      id: '6489757679bab1cda77e00fa'
    }
    this.coursesService.getMockStatus(reqObj).subscribe(res => {
      if (res.success && res.data.mockList.length > 0) {
        this.fullmockDetailList.forEach(mock => {
          res.data.mockList.forEach((item: any) => {
            if (item._id == mock._id) {
              mock.attemptAllowed = item.attemptAllowed;
              mock.attemptList = item.attemptList;
              mock.isWindowPeriod = item.isWindowPeriod;
            }
          })
        })
      }
    })
    this.getSectionalQuantStatus()
  }

  getSectionalQuantStatus() {
    let reqObj = {
      uid: this.mockData.uid,
      id: '64a7c1722afd6e4967cd3794'
    }
    this.coursesService.getTestMockStatus(reqObj).subscribe(res => {
      if (res.success  && res.data.mockList.length > 0) {
        this.quantMockList.forEach(mock => {
          res.data.mockList.forEach((item: any) => {
            if (item._id == mock._id) {
              mock.attemptAllowed = item.attemptAllowed;
              mock.attemptList = item.attemptList;
              mock.isWindowPeriod = item.isWindowPeriod;
            }
          })
        })
      }
    })
    this.getSectionalLrdiStatus()
  }

  getSectionalLrdiStatus() {
    let reqObj = {
      uid: this.mockData.uid,
      id: '64a7c1e12afd6e4967cd37b4'
    }
    this.coursesService.getTestMockStatus(reqObj).subscribe(res => {
      if (res.success  && res.data.mockList.length > 0) {
        this.lrdiMockList.forEach(mock => {
          res.data.mockList.forEach((item: any) => {
            if (item._id == mock._id) {
              mock.attemptAllowed = item.attemptAllowed;
              mock.attemptList = item.attemptList;
              mock.isWindowPeriod = item.isWindowPeriod;
            }
          })
        })
      }
    })
    this.getSectionaliimStatus()
  }

  getSectionaliimStatus() {
    let reqObj = {
      uid: this.mockData.uid,
      id: '64a7c1e12afd6e4967cd37b4'
    }
    this.coursesService.getTestMockStatus(reqObj).subscribe(res => {
      if (res.success && res.data.mockList.length > 0) {
        this.iim.forEach(mock => {
          res.data.mockList.forEach((item: any) => {
            if (item._id == mock._id) {
              mock.attemptAllowed = item.attemptAllowed;
              mock.attemptList = item.attemptList;
              mock.isWindowPeriod = item.isWindowPeriod;
            }
          })
        })
      }
    })
    this.getSectionalVarcStatus()
  }

  getSectionalVarcStatus() {
    let reqObj = {
      uid: this.mockData.uid,
      id: '65cb598c42702cd3b13867c8'
    }
    this.coursesService.getTestMockStatus(reqObj).subscribe(res => {
      if (res.success && res.data.mockList.length > 0) {
        this.varcMockList.forEach(mock => {
          res.data.mockList.forEach((item: any) => {
            if (item._id == mock._id) {
              mock.attemptAllowed = item.attemptAllowed;
              mock.attemptList = item.attemptList;
              mock.isWindowPeriod = item.isWindowPeriod;
            }
          })
        })
      }
    })
    this.getPyqStatus()
  }

  getPyqStatus(){
      let reqObj = {
        uid: this.mockData.uid,
        id: '6716026a23f7069204fc5a4f'
      }
      this.coursesService.getTestMockStatus(reqObj).subscribe(res => {
        if (res.success && res.data.mockList.length > 0) {
          this.pyqmock.forEach(mock => {
            res.data.mockList.forEach((item: any) => {
              if (item._id == mock._id) {
                mock.attemptAllowed = item.attemptAllowed;
                mock.attemptList = item.attemptList;
                mock.isWindowPeriod = item.isWindowPeriod;
              }
            })
          })
        }
      })
      this.getrohtakStatus()
  }

  getrohtakStatus(){
    let reqObj = {
      uid: this.mockData.uid,
      id: '6736fc560ff2adb91aeb10e6'
    }
    this.coursesService.getTestMockStatus(reqObj).subscribe(res => {
      if (res.success && res.data.mockList.length > 0) {
        this.Rohtak.forEach(mock => {
          res.data.mockList.forEach((item: any) => {
            if (item._id == mock._id) {
              mock.attemptAllowed = item.attemptAllowed;
              mock.attemptList = item.attemptList;
              mock.isWindowPeriod = item.isWindowPeriod;
            }
          })
        })
      }
    })
}

getIndoreVAStatus(){
  let reqObj = {
    uid: this.mockData.uid,
    id: '6736fc560ff2adb91aeb10e6'
  }
  this.coursesService.getTestMockStatus(reqObj).subscribe(res => {
    if (res.success && res.data.mockList.length > 0) {
      this.IndoreVA.forEach(mock => {
        res.data.mockList.forEach((item: any) => {
          if (item._id == mock._id) {
            mock.attemptAllowed = item.attemptAllowed;
            mock.attemptList = item.attemptList;
            mock.isWindowPeriod = item.isWindowPeriod;
          }
        })
      })
    }
  })
}

getKozhikodeStatus(){
  let reqObj = {
    uid: this.mockData.uid,
    id: '685130d83c08a3e66e3b431c'
  }
  this.coursesService.getTestMockStatus(reqObj).subscribe(res => {
    if (res.success && res.data.mockList.length > 0) {
      this.Kozhikode.forEach(mock => {
        res.data.mockList.forEach((item: any) => {
          if (item._id == mock._id) {
            mock.attemptAllowed = item.attemptAllowed;
            mock.attemptList = item.attemptList;
            mock.isWindowPeriod = item.isWindowPeriod;
          }
        })
      })
    }
  })
}


getINDOREQAMCQStatus(){
  let reqObj = {
    uid: this.mockData.uid,
    id: '67c840a43023d5fa9a87150d'
  }
  this.coursesService.getTestMockStatus(reqObj).subscribe(res => {
    if (res.success && res.data.mockList.length > 0) {
      this.IndoreVA.forEach(mock => {
        res.data.mockList.forEach((item: any) => {
          if (item._id == mock._id) {
            mock.attemptAllowed = item.attemptAllowed;
            mock.attemptList = item.attemptList;
            mock.isWindowPeriod = item.isWindowPeriod;
          }
        })
      })
    }
  })
}

  resetAccount(){
         this.matSnackBar.open('If you are facing any issues in Attempting, Please contact iQuanta Support - 8448350597', 'OK', {
        verticalPosition: 'top',
        panelClass: 'snack-error'
      })
    // this.coursesService.resetAccount(this.profileData.email, this.profileData.id).subscribe(res=>{
    //   this.matSnackBar.open('Please Login to Proceed', 'OK', {
    //     verticalPosition: 'top',
    //     duration: 3000,
    //     panelClass: 'snack-error'
    //   })
    //   this.sessionStorage.clear();
    
    // this.token = '';
    // this.profileData = '';
    // this.loginService.userProfile('')
    // this.router.navigate(['/'])
    // })
  }



  allMocksIdsList:any[]=[];
  selectedMockID:any;

  getMocksPages(){
    this.coursesService.getMocksBasedOnPages().subscribe((res:any)=>{
      this.allMocksIdsList = res;
    let data:any =  this.allMocksIdsList.filter((x:any)=> 
        x.title == 'CAT 2024'
      )[0];
      this.selectedMockID = data['_id']['$oid']
      this.getExternalMocks()
    })
  }

  
  displayTooltip() {
    this.myTooltip.disabled = false;
    this.myTooltip.show()
    setTimeout(() => {
      this.myTooltip.disabled = true;
    }, 1000);
  }

  goto(id: any) {
    var elemnt: any = document.getElementById(id)
    elemnt.scrollIntoView({ block: 'start' })
  }

  getExternalMocks(){
    this.coursesService.getMocksOnId(this.selectedMockID).subscribe(res=>{
      if(res.success){
        this.fullmockDetailList = res.data.mocklist.sort((a:any, b:any)=> a.title > b.title ? 1:-1);
        this.getMocks()
      }
    })
  }

  loadmore() {
    if (this.tabVal == 'full') {
      this.loadmore1 = this.loadmore1 + 5;
    } else if(this.tabVal == 'unproctored') {
      this.loadmore3 = this.loadmore3 + 5;
    } else if(this.tabVal == 'freemocks'){
      this.loadmore4 = this.loadmore4 + 5;
    }else if(this.tabVal == 'pyq'){
      if(this.tabVal1 == 'quant'){
        this.loadmore5 = this.loadmore5 + 7;
      }
     if(this.tabVal1 == 'lrdi'){
      this.loadmore5 = this.loadmore5 + 3;
     }
     if(this.tabVal1 == 'varc'){
      this.loadmore5 = this.loadmore5 + 5;
     }

    }
    else{
      this.loadmore2 = this.loadmore2 + 5;
    }
    
  }

  loadless() {
    if (this.tabVal == 'full') {
      this.loadmore1 = 5;
    } else if(this.tabVal == 'unproctored'){
      this.loadmore3 = 5;
    }else if(this.tabVal == 'freemocks'){
      this.loadmore4 = 5;
    }
    else if(this.tabVal == 'pyq'){
      if(this.tabVal1 == 'quant'){
        this.loadmore5 =  7;
      }
     if(this.tabVal1 == 'lrdi'){
      this.loadmore5 = 3;
     }
     if(this.tabVal1 == 'varc'){
      this.loadmore5 = 5;
     }
    }
    else{
      this.loadmore2 = 5
    }
  }

  payMocks() {
    let mocks: any[] = [];
    this.fullmockDetailList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "6489757679bab1cda77e00fa",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionalQuant()
  }

  paySectionalQuant() {
    let mocks: any[] = [];
    this.quantMockList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65cb50c77d768c2af04f84a4",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionalLrdi()

  }

  paySectionalNPAT() {
    let mocks: any[] = [];
    this.NPATMockList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65cb50c77d768c2af04f84a4",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionalNPAT()

  }

  paySectionalSET() {
    let mocks: any[] = [];
    this.SETMockList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65cb50c77d768c2af04f84a4",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionalSET()

  }

  paySectionalChrist() {
    let mocks: any[] = [];
    this.SETMockList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65cb50c77d768c2af04f84a4",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionalChrist()

  }

  payIndoreVA() {
    let mocks: any[] = [];
    this.SETMockList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "67ea1b052502fe28e4bfbc23",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.payINDOREQAMCQ()

  }

  payINDOREQAMCQ() {
    let mocks: any[] = [];
    this.SETMockList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "67c840a43023d5fa9a87150d",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionalChrist()

  }

  paySectionalLrdi() {
    let mocks: any[] = [];
    this.lrdiMockList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65cb598c42702cd3b13867c8",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionaliim()
  }

  paySectionaliim() {
    let mocks: any[] = [];
    this.iim.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65cb598c42702cd3b13867c8",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionalVarc()
  }

  paySectionalVarc() {
    let mocks: any[] = [];
    this.varcMockList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65cb50677d768c2af04f84a3",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
  }

   payKozhikode() {
    let mocks: any[] = [];
    this.varcMockList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "685130d83c08a3e66e3b431c",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
  }

  setPaidUnPaid(purchasedCourses: any) {
console.log(purchasedCourses)
    purchasedCourses.forEach((mock: any) => {
   
      if (mock.bundle_lt) {
        this.fullmockDetailList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
        
          ids.forEach((bundle: any) => {
       
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
          // if(JSON.parse(mock.bundle_lt).includes(fullmock._id)){
          //   fullmock.paid = false;
          // }
        })
        this.lrdiMockList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.iim.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.varcMockList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.quantMockList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.NPATMockList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.SETMockList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.CHRISTMockList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.IndoreVA.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.INDOREQAMCQ.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
         this.Kozhikode.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })

      }
    })

    this.allMocksList = this.fullmockDetailList.concat(this.lrdiMockList.concat(this.iim.concat(this.quantMockList.concat(this.varcMockList.concat(this.NPATMockList.concat(this.SETMockList.concat(this.CHRISTMockList.concat(this.IndoreVA.concat(this.INDOREQAMCQ.concat(this.Kozhikode.concat))))))))))
    this.payMocks()
  }

}

